angular
  .module('surfsightApp.controllers')
  .controller('EditEdgeGroupController', [
    '$scope',
    '$state',
    '$http',
    '$localStorage',
    '$mdDialog',
    '$mdToast',
    '$interval',
    'dataFromCaller',
    function (
      $scope,
      $state,
      $http,
      $localStorage,
      $mdDialog,
      $mdToast,
      $interval,
      dataFromCaller
    ) {
      $scope.edge_group_id = dataFromCaller.edge_group_id
      $scope.loading = true
      $scope.form_submit_inprogress = false
      var request_json = {
        method: 'GET',
        url: EDGE_BASEURL + '/edge_groups/' + $scope.edge_group_id
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            $scope.editedge_group_data = response.data.edgeGroup
          }
          $scope.loading = false
        },
        function (response) {
          handleServerError(response)
          $scope.showMessageToast(response.data.status.error)
        }
      )
      $scope.editEdgeGroup = function () {
        $scope.form_submit_inprogress = true
        var request_json = {
          method: 'PUT',
          url: EDGE_BASEURL + '/edge_groups/' + $scope.edge_group_id,
          data: $scope.editedge_group_data
        }
        $http(request_json).then(function (response) {
          $scope.form_submit_inprogress = false
          if (response.data.status.code == 0) {
            $mdDialog.hide(response)
          } else {
            var toast = $mdToast
              .simple()
              .textContent(response.data.status.error)
              .action($translate('ok'))
              .position('bottom')
              .actionKey('F1')
              .hideDelay(5000)
              .parent('#edit-edge-container')

            $mdToast
              .show(toast)
              .then(function (response) {
                if (response == 'ok') {
                }
              })
              .catch(() => {})
          }
        })
      }
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .parent('#edit-edge-group-container')
          .hideDelay(5000)

        $mdToast
          .show(toast)
          .then(function (response) {
            if (response == 'ok') {
            }
          })
          .catch(() => {})
      }
      $scope.cancel = function () {
        $mdDialog.cancel()
      }
      function handleServerError (response) {
        $scope.$emit('handleServerError', response)
      }
    }
  ])
